module.exports = __webpack_public_path__ + "static/media/no_data.ea3f92e6.svg";